<template>
    <div>

        <form-progress /> 
         
        <div 
        class="row mt-3"
        v-if="section">

            <div class="col-md-12">
                
                <div class="row">
                    <form-row 
                    v-for="row in rows"
                    :key="'row-'+row.id" 
                    :row="row" />
                </div> <!-- /.row -->


                <transition-group name="slide-fade">
                    <form-section
                    :key="section.id"
                    :section="section" />
                </transition-group>


                <div class="mt-3 d-flex justify-content-between">

                    <button 
                    key="btn-prev"
                    :disabled="_.first(sections).id == section.id"
                    @click="prevSection()"
                    class="btn btn-outline-primary">
                        Précédant
                    </button>

                    <loading-button 
                    :loading="loading"
                    :disabled="stop || progress.percentage != 100"
                    v-if="_.last(sections).id == section.id"
                    @click="submit()"
                    class="d-inline-block btn btn-primary">
                        Terminer
                    </loading-button>

                    <button 
                    v-else
                    :disabled="stop"
                    @click="nextSection()"
                    class="d-inline-block btn btn-primary">
                        Suivant
                    </button>

                </div> <!-- /.d-flex -->

            </div> <!-- /.col -->

        </div> <!-- /.row -->

    </div>
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {

        data() {
            return {
                loading: false,
                section: null
            }
        },

        computed: {

            _() {
                return _;
            },
            
            index() {
                return _.findIndex(this.sections, s => s.id == this.section.id )
            },

            ...mapGetters('form', [
                'answers',
                'rows',
                'sections',
                'stop',
                'progress'
            ])
        },

        methods: {
            
            setSection(id) {

                this.section = _.find(
                    this.sections, 
                    section => section.id == id
                )
            },

            prevSection() {
                this.section = this.sections[this.index - 1]
            },

            nextSection() {
                this.section = this.sections[this.index + 1]
            },

            submit() {
                this.$emit('submit')
            }
        },

        mounted() {
            this.section = _.first(this.sections)
        }
        

    }

</script>